export const EMAIL_MARKER = "[[WL-EMAIL]]";

export type BlockType = "header" | "chip" | "paragraph" | "summary" | "notes" | "button" | "divider" | "footer";

export interface SummaryRow {
	label?: string;
	value?: string;
	emphasis?: boolean;
	inline?: boolean;
	/** Raw passthrough line (e.g. "# Section Header") — when set, label/value are ignored. */
	raw?: string;
	/**
	 * Pair-column fields. When label2 + value2 are set this row renders as two 50% cells
	 * side-by-side and serializes as "Label: value | Label2: value2".
	 * Backward-compatible — absent on single-column rows.
	 */
	label2?: string;
	value2?: string;
	emphasis2?: boolean;
}

export interface NoteRow {
	k: string;
	v: string;
}

export interface BlockData {
	// header
	eyebrow?: string;
	title?: string;
	subtitle?: string;
	/**
	 * Freeform content lines inside the header banner (below subtitle).
	 * Serialised as zero or more `Line: <text>` entries.
	 * Shared field name with footer/notes lines — context (block.type) disambiguates.
	 */
	lines?: string[];
	// chip / button / paragraph
	text?: string;
	html?: string;
	label?: string;
	// summary
	rows?: SummaryRow[] | NoteRow[];
	// notes
	items?: string[];
	note?: string;
}

export interface Block {
	id?: string;
	type: BlockType;
	required?: boolean;
	style?: {
		color?: "info" | "warning" | "neutral";
		layout?: "list" | "rows" | "inline" | "stacked";
		radius?: number;
		density?: "compact" | "comfortable" | "spacious";
	};
	data: BlockData;
	requiredVars?: string[];
}
